import JwtEncode from 'jwt-encode'

export function encode (data: unknown, secret: string) {
  return JwtEncode(data, secret)
}
